<template>
    <Form class="iform">
        <Form-item>
            <label>原密码 Old Password</label>
            <i-input v-model="passwordData.oldPassword" type="password" class="ipt" autofocus>
                <Icon type="ios-lock-outline" slot="prepend"></Icon></i-input>
        </Form-item>
        <Form-item>
            <label>新密码 New Password</label>
            <i-input v-model="passwordData.newPassword" placeholder="新密码 New Password" type="password" class="ipt">
                <Icon type="ios-lock-outline" slot="prepend"></Icon></i-input>
        </Form-item>
        <Form-item>
            <label>重复新密码 New Password2</label>
            <i-input v-model="passwordData.newPassword2" placeholder="重复新密码 New Password2" type="password" class="ipt" @keyup.enter.native="modifyPassword">
                <Icon type="ios-lock-outline" slot="prepend"></Icon></i-input>
        </Form-item>
        <div style="display:flex;justify-content: center;"><Button @click="modifyPassword" size="large" type="primary">修改密码</Button></div>
    </Form>
</template>

<style scoped>
    div.ivu-form-item-content>label{width:25%;text-align:right;margin-right:10px;word-break:keep-all;}
    .ipt{width:70%;}
</style>
<script>
export default {
    data:()=>{
        return {
            passwordData:{}
        }
    },
    computed:{
    },
    watch:{
    },
    created:function(){},
    mounted:function(){},
    methods:{
        modifyPassword(){
            for (var i in this.passwordData){
                if (!/.{5,}/.test(this.passwordData[i])){
                    this.$Message.error('密码太短！');
                    this.passwordData[i]=''
                    return
                }
            }
            if (this.passwordData.newPassword!=this.passwordData.newPassword2){
                this.$Message.error('两次密码不一致！');
                this.passwordData.newPassword2=''
                return
            }
            this.db_api('post',this.api,{req:'update_own_password',old_password:this.passwordData.oldPassword,new_password:this.passwordData.newPassword}).then(()=>{this.$Message.info('修改密码成功！')})
            this.passwordData={}
        },
    }
}
</script>